import React from 'react';

const Linear_Functions = () => {
    return (
        <div>Linear_Functions Component</div>
    );
}

export default Linear_Functions;
